// extracted by mini-css-extract-plugin
export default {"SignUp":"ThankYou_SignUp__9plbi","Border":"ThankYou_Border__+-7G9","InputClass":"ThankYou_InputClass__GKQVy","Button":"ThankYou_Button__z54mP","Image":"ThankYou_Image__l+Q3O"};